import { DESKTOP_VIEWPORT } from "../../../hooks/useViewport";
/**
 * Race 20 card helpers — same parsing as the reference admin (Vue race20 page / result modal):
 * each token except "1" (card back) counts as a card; its suit is the last 2 chars
 * (4-char tokens like "10SS" -> "SS"); points use A=1, J=11, Q=12, number cards = face value.
 * The kings are never part of the card string — each suit row ends with its K card.
 */
const BASE = import.meta.env.BASE_URL;

export const RACE20_CARDS_PATH = `${BASE}img/cards`;
export const race20CardImg = (token) => `${RACE20_CARDS_PATH}/${token}.png`;

export const RACE20_SUITS = [
  { key: "SS", icon: "spade", king: "KSS" },
  { key: "HH", icon: "heart", king: "KHH" },
  { key: "CC", icon: "club", king: "KCC" },
  { key: "DD", icon: "diamond", king: "KDD" },
];

export function parseRace20Cards(cardString) {
  const cards = String(cardString ?? "").split(",").map((c) => c.trim());
  const bySuit = { SS: [], HH: [], CC: [], DD: [] };
  let totalPoints = 0;
  let totalCards = 0;
  for (const token of cards) {
    let suit = "";
    let rank = "0";
    if (token !== "1") {
      if (token.length === 4) {
        suit = token.slice(2);
        rank = token.slice(0, 2);
      } else {
        suit = token.slice(1);
        rank = token.slice(0, 1);
      }
      totalCards += 1;
    }
    if (bySuit[suit]) bySuit[suit].push(token);
    if (rank === "Q") rank = 12;
    if (rank === "J") rank = 11;
    if (rank === "A") rank = 1;
    const n = parseInt(rank, 10);
    if (!Number.isNaN(n)) totalPoints += n;
  }
  return { cards, bySuit, totalCards, totalPoints };
}

/**
 * Reference `$store.getters.isTablet`: documentElement width >= 768 at load. The reference has no
 * viewport meta, so a phone already lays out at 980px when that runs; our `width=980` meta
 * (DESKTOP_VIEWPORT, set by Layout) lands only after this module loads, so floor the width at it.
 */
const LAYOUT_MIN_WIDTH = parseInt(String(DESKTOP_VIEWPORT).replace(/^.*width=(\d+).*$/, "$1"), 10) || 0;
export const RACE20_IS_TABLET = (() => {
  if (typeof window === "undefined") return true;
  let w = document.documentElement.clientWidth;
  if (window.innerWidth && w > window.innerWidth) w = window.innerWidth;
  return Math.max(w, LAYOUT_MIN_WIDTH) >= 768;
})();
